import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { InstalacionAutorizadaService } from './instalacionautorizada.service';
import { InstalacionAutorizadaViewModel } from './instalacionautorizada.types';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { Tc } from '../../../core/_infrastructure/types/common';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';

@Component({
    selector: 'app-instalacionautorizada-edit',
    templateUrl: './instalacionautorizada-edit.component.html',
})
export class InstalacionAutorizadaEditComponent extends ComponentBase implements OnInit {
    editMode: boolean;
    editTitle: string = 'Nueva';

    listProvincias: Tc[];

    instalacionAutorizada: InstalacionAutorizadaViewModel;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        private instalacionAutorizadaService: InstalacionAutorizadaService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);
        this.instalacionAutorizada = new InstalacionAutorizadaViewModel();
    }

    ngOnInit() {
        this.createForm();

        let id = +this.activatedRoute.snapshot.params['id'];

        if (id) {
            this.editMode = true;
            this.editTitle = 'Editar';

            this.instalacionAutorizadaService.getInstalacionAutorizada(id).subscribe(result => {
                this.instalacionAutorizada = result;
                this.updateForm();
            });
        }

        this.globalService.getProvincias().subscribe(res => {
            this.listProvincias = res;
        });
    }

    createForm() {
        this.form = this.fb.group({
            Descripcion: ['', Validators.required],
            NumRegistro: ['', Validators.required],
            IdProvincia: [null, Validators.required],
            Direccion: ['', Validators.required],
            Localidad: ['', Validators.required],
            CodigoPostal: ['', Validators.required],
            Activo: true,
        });
    }

    updateForm() {
        this.form.setValue({
            Descripcion: this.instalacionAutorizada.Descripcion,
            NumRegistro: this.instalacionAutorizada.NumRegistro,
            IdProvincia: this.instalacionAutorizada.IdProvincia,
            Direccion: this.instalacionAutorizada.Direccion,
            Localidad: this.instalacionAutorizada.Localidad,
            CodigoPostal: this.instalacionAutorizada.CodigoPostal,
            Activo: this.instalacionAutorizada.Activo,
        });
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos');
            return;
        }

        let instalacionAutorizada = new InstalacionAutorizadaViewModel();

        instalacionAutorizada.Descripcion = this.form.value.Descripcion;
        instalacionAutorizada.NumRegistro = this.form.value.NumRegistro;
        instalacionAutorizada.IdProvincia = this.form.value.IdProvincia;
        instalacionAutorizada.Direccion = this.form.value.Direccion;
        instalacionAutorizada.Localidad = this.form.value.Localidad;
        instalacionAutorizada.CodigoPostal = this.form.value.CodigoPostal;
        instalacionAutorizada.Activo = this.form.value.Activo;

        instalacionAutorizada.Id = this.instalacionAutorizada.Id;

        if (this.editMode) {
            this.instalacionAutorizadaService.editInstalacionAutorizada(instalacionAutorizada).subscribe({
                next: () => {
                    this.addSuccessMessage('Instalación Autorizada modificada correctamente');
                    this.onBack();
                },
                error: error => this.catchServerError(error),
            });
        } else {
            this.instalacionAutorizadaService.createInstalacionAutorizada(instalacionAutorizada).subscribe({
                next: () => {
                    this.addSuccessMessage('Instalación Autorizada añadida correctamente');
                    this.onBack();
                },
                error: error => this.catchServerError(error),
            });
        }
    }

    onBack() {
        this.router.navigate(['/mantenimiento/general/instalacionesautorizadas']);
    }
}
